import { render, staticRenderFns } from "./CafeTable.vue?vue&type=template&id=2c6a900e&"
import script from "./CafeTable.vue?vue&type=script&lang=js&"
export * from "./CafeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/hanmail/src/cafe-top/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2c6a900e', component.options)
    } else {
      api.reload('2c6a900e', component.options)
    }
    module.hot.accept("./CafeTable.vue?vue&type=template&id=2c6a900e&", function () {
      api.rerender('2c6a900e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/common/CafeTable.vue"
export default component.exports